import React from 'react';
import styled from '@emotion/styled';
import { Contact, Order } from '../types';
import groupBy from 'lodash.groupby';
import { GroupedByIcon } from '../../components/icons';

const SidebarStyles = styled.div`
  display: none;
  @media (min-width: 1260px) {
    border: 1.5px solid #eae8e5;
    border-radius: 5px;
    font-size: 14px;
    padding: 40px 16px;
    display: block;
    margin-left: 32px;
    width: 100%;
    max-width: 402px;
  }
  .card-header {
    font-weight: 700;
    font-size: 20px;
    padding-left: 24px;
    height: 56px;
  }
  .type-group {
    padding: 16px 24px;
    border-top: 1px solid #e5e5ea;
  }
  .person-type {
    color: #8e8e93;
    font-size: 14px;
  }
`;
const InputStyles = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  color: #444;
  text-transform: uppercase;
  line-height: 28px;
`;
interface Props {
  contact: Contact[];
  order: Order;
}
const groupByType = (contacts: Contact[]) => {
  return groupBy(contacts, 'contactType');
};
const Sidebar = (props: Props) => {
  const grouped = groupByType(props.contact);

  return (
    <SidebarStyles>
      <div className="card-header">Names</div>
      <>
        {Object.keys(grouped).map(key => {
          return (
            <div className="type-group">
              <div className="person-type">
                {key === 'Borrower' ? (props.order.isPurchase ? 'Buyer' : 'Borrower') : key}
              </div>
              {grouped[key].map(c => {
                return <InputStyles>{c.name}</InputStyles>;
              })}
            </div>
          );
        })}
      </>
    </SidebarStyles>
  );
};

export default Sidebar;
